import React from 'react';
import QRCode from 'react-qr-code';
import { useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import { SText } from 'src/components/SText';
import { inStoreSubmitDataSuccessSelector } from '../store';
interface Props {
  clientDemandId: string;
  tel: string;
}

type InStoreSuccessRouteParams = {
  clientDemandId: string;
  tel: string;
};

export const InStoreSuccess: React.FC<Props> = () => {
  const successSubmitData = useSelector(inStoreSubmitDataSuccessSelector);
  const params = useParams<InStoreSuccessRouteParams>();
  return (
    <div className="flex justify-center items-center">
      <div>
        <SText label="instore-success.success-title-code-qr" classNames="block my-4 text-center text-xl" />
        <div className="flex justify-center">
          <QRCode value={`https://smartcolis.com/d/clientDemand/${params.clientDemandId}`} />
        </div>
        <div>
          <SText label={params.tel} classNames="text-primary font-regular text-2xl text-center block my-6" />
        </div>
      </div>
    </div>
  );
};
